const $ = jQuery.noConflict();
import '@fancyapps/fancybox';

'use strict';
const Fancybox = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */


	/** @description Initialize */
	init: function() {
		this.fancyboxPopup('.js-popup-trigger', '.js-popup', 'popup-custom-class');
		this.fancyboxPopup('.js-product-tile-popup-trigger', '.js-product-tile-popup', 'product-tile-popup');
		this.fancyboxPopup('.js-calculate-savings-popup-trigger', '.js-calculate-savings-popup', 'callout-split-popup');
		this.fancyboxPopup('.js-get-certified-popup-trigger', '.js-get-certified-popup', 'callout-split-popup');
		this.setupMagnifier();
		this.setupMediaListVideos();
		// this.fancyboxPopup('.js-product-gallery-popup-trigger', '.js-product-gallery-popup');
	},

	/**
	 * @description Fancy box custom popup functionality.
	 * @link documentation https://fancyapps.com/fancybox/3/docs/#inline
	 * @example this.functions.fancyboxPopup('.popup-btn', '.popup', 'my-custom-class');
	 * @param {string} trigger - popup trigger
	 * @param {string} popup - popup wrapper class
	 * @param {string} customClass - custom class for each popup (optional)
	 */
	fancyboxPopup: (trigger, popup, customClass = '') => {
		$(trigger).fancybox({
			src: popup,
			type: 'inline',
			smallBtn: true,
			baseClass: customClass
		});
	},

	setupMagnifier: function() {
		$(document).on('click', '.js-product-magnifier', function() {
			const $image = $(this).find('.js-product-slider-image');
			if ($image.length) {
				$.fancybox.open([
					{
						src: $image.attr('src'),
						type: 'image',
						opts: {
							baseClass: 'trusted-by__popup-wrap',
							smallBtn: true,
							touch: false,
							closeExisting: true,
						}
					}
				]);
			}
		});
	},

	setupMediaListVideos: function() {
		$('.js-media-list-video-trigger').fancybox({
			youtube: {
				autoplay: 1,
				controls: 1,
				rel: 0,
				showinfo: 0
			},
			vimeo: {
				autoplay: 1
			},
			protect: true,
			baseClass: 'media-list-video-popup',
			touch: {
				vertical: false
			}
		});
	}
};

export default Fancybox;
